(function () {
  var M = window.MallKop = window.MallKop || {};
  M.money = function (c, cfg) {
    var a = c / 100, whole = c % 100 === 0 && cfg.noDecimals;
    function num(ts, ds) { var s = a.toFixed(whole ? 0 : 2).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return s[1] ? s[0] + ds + s[1] : s[0]; }
    return cfg.fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k.indexOf('no_decimals') > -1) whole = true;
      if (k.indexOf('space') > -1) return num(' ', ',');
      if (k.indexOf('comma') > -1) return num('.', ',');
      if (k.indexOf('apostrophe') > -1) return num("'", '.');
      return num(',', '.');
    });
  };
  M.mount = function (slot) {
    slot = slot || document.querySelector('.mall-kop-slot');
    var tpl = document.getElementById('MallKopTpl');
    if (!slot || !tpl) return;
    slot.innerHTML = '';
    slot.appendChild(tpl.content.cloneNode(true));
    var root = slot.querySelector('.mk');
    var cfg = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
    var info = slot.closest('.product__info-container');
    if (info) info.classList.toggle('mall-kop-on', !!cfg.hideTheme);
    M.init(root, cfg, info);
  };
  M.init = function (root, cfg, info) {
    var P = cfg.product, V = P.variants;
    var multi = !(V.length === 1 && /default/i.test(V[0].title));
    var bars = [].slice.call(root.querySelectorAll('.mk-bar'));
    var btn = root.querySelector('.mk-atc'), err = root.querySelector('.mk-err');
    function byId(id) { for (var i = 0; i < V.length; i++) if (V[i].id == id) return V[i]; return V[0]; }
    function byOpts(o) { for (var i = 0; i < V.length; i++) { var ok = true; for (var k = 0; k < o.length; k++) if (V[i].options[k] !== o[k]) ok = false; if (ok) return V[i]; } return null; }
    function current() { var f = info && info.querySelector('form[action*="/cart/add"] input[name="id"]'); return f && f.value ? byId(f.value) : V[0]; }
    var units = bars.map(function (b) { var q = +b.dataset.qty || 1, a = []; for (var i = 0; i < q; i++) a.push(current().id); return a; });
    var sel = Math.max(0, bars.findIndex(function (b) { return b.classList.contains('is-on'); }));
    function values(k) { var seen = []; V.forEach(function (v) { if (seen.indexOf(v.options[k]) < 0) seen.push(v.options[k]); }); return seen; }
    function img(v) { var s = (v.featured_image && v.featured_image.src) || P.featured_image; return s ? (s.indexOf('//') === 0 ? 'https:' + s : s) + (s.indexOf('?') > -1 ? '&' : '?') + 'width=80' : ''; }
    function fill(el, i, p, full, pct) {
      if (!el) return;
      el.textContent = el.dataset.tpl.replace(/\[styckpris\]/g, M.money(Math.round(p / units[i].length), cfg)).replace(/\[rabatt\]/g, pct + '%').replace(/\[spara\]/g, M.money(Math.max(full - p, 0), cfg)).replace(/\[antal\]/g, units[i].length);
    }
    function price(i) {
      var b = bars[i], pct = +b.dataset.pct || 0, fixed = Math.round((parseFloat(String(b.dataset.fixed || '').replace(',', '.')) || 0) * 100), tot = 0, cmp = 0, p, full;
      units[i].forEach(function (id) { var v = byId(id); tot += v.price; cmp += Math.max(v.compare_at_price || 0, v.price); });
      if (fixed > 0) { p = fixed; full = Math.max(cmp, tot); }
      else { p = Math.round(tot * (100 - pct) / 100); full = pct > 0 ? Math.max(tot, cmp) : (cmp > tot ? cmp : 0); }
      var shown = full > p ? Math.round((1 - p / full) * 100) : pct;
      b.querySelector('.mk-price').textContent = M.money(p, cfg);
      b.querySelector('.mk-full').textContent = cfg.showCompare && full > p ? M.money(full, cfg) : '';
      fill(b.querySelector('.mk-sub'), i, p, full, shown);
      fill(b.querySelector('.mk-label'), i, p, full, shown);
    }
    function drawUnits(i) {
      var box = bars[i].querySelector('.mk-units'); box.innerHTML = '';
      if (!multi || !cfg.showVariants || (units[i].length < 2 && info && info.querySelector('variant-selects, variant-radios'))) return;
      var lab = document.createElement('div'); lab.className = 'mk-uname'; lab.textContent = P.options.map(function (o) { return o.name || o; }).join(' / '); box.appendChild(lab);
      units[i].forEach(function (id, u) {
        var v = byId(id), row = document.createElement('div'); row.className = 'mk-unit';
        var im = document.createElement('img'); im.className = 'mk-uimg'; im.alt = ''; im.src = img(v); row.appendChild(im);
        var wrap = document.createElement('div'); wrap.className = 'mk-uselects';
        P.options.forEach(function (o, k) {
          var s = document.createElement('select'); s.setAttribute('aria-label', (o.name || o) + ' ' + (u + 1));
          values(k).forEach(function (val) { var op = document.createElement('option'); op.value = op.textContent = val; if (val === v.options[k]) op.selected = true; s.appendChild(op); });
          s.addEventListener('change', function () {
            var o2 = [].map.call(wrap.querySelectorAll('select'), function (x) { return x.value; });
            var nv = byOpts(o2); if (!nv) return;
            units[i][u] = nv.id; im.src = img(nv); price(i);
          });
          s.addEventListener('click', function (e) { e.stopPropagation(); });
          wrap.appendChild(s);
        });
        row.appendChild(wrap); box.appendChild(row);
      });
    }
    function pick(i) {
      sel = i;
      bars.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-checked', k === i ? 'true' : 'false'); });
      drawUnits(i);
    }
    bars.forEach(function (b, i) {
      price(i);
      b.addEventListener('click', function () { if (sel !== i) pick(i); });
      b.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(i); } });
    });
    pick(sel);
    document.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('variant-selects, variant-radios')) return;
      setTimeout(function () { var c = current().id; units = units.map(function (a) { return a.map(function () { return c; }); }); bars.forEach(function (b, i) { price(i); }); pick(sel); }, 120);
    });
    var busy = false;
    function done() { busy = false; btn.removeAttribute('aria-busy'); }
    btn.addEventListener('click', function () {
      if (busy) return;
      busy = true;
      var map = {}, items = [];
      units[sel].forEach(function (id) { map[id] = (map[id] || 0) + 1; });
      Object.keys(map).forEach(function (id) { items.push({ id: +id, quantity: map[id] }); });
      var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      function post(u, b) { return fetch(base + u, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b || {}) }); }
      btn.setAttribute('aria-busy', 'true'); err.hidden = true;
      post('cart/clear.js')
        .then(function () { return post('cart/add.js', { items: items }); })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status && d.description) { done(); err.textContent = d.description; err.hidden = false; return; }
          location.href = base + 'checkout';
        })
        .catch(function () { done(); location.href = base + 'cart'; });
    });
    window.addEventListener('pageshow', done);
  };
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector && e.target.querySelector('#MallKopTpl')) M.mount(); });
})();